import { cloudStorage, initDataRaw } from '@telegram-apps/sdk-react';
import axios, { type AxiosInstance, type AxiosRequestConfig, type InternalAxiosRequestConfig } from 'axios';
import UserService from '../service/user';

const rawApi: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: false,
  responseType: 'json',
});

const adminRawApi: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_URL,
  withCredentials: false,
  responseType: 'json',
});

const chatRawApi: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_CHAT_API_URL,
  withCredentials: false,
  responseType: 'json',
});

const botRawApi: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BOT_BACKEND_URL,
  withCredentials: false,
  responseType: 'json',
});

// 🔐 Добавляем токен
rawApi.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = await cloudStorage.getItem('accessToken');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['language'] = Number(localStorage.getItem('languageId') || 1);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

chatRawApi.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = await cloudStorage.getItem('accessToken');
    console.log(`http index.ts ${token}`);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

rawApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      try {
        await UserService.logout();
      } catch (e) {
        console.error(e);
      }
      await cloudStorage.deleteItem('accessToken');
      // miniApp.close();
    }

    return Promise.reject(error);
  },
);

adminRawApi.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    config.headers = config.headers || {};
    config.headers['language'] = Number(localStorage.getItem('languageId') || 1);
    return config;
  },
  (error) => Promise.reject(error),
);

botRawApi.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    config.headers.Authorization = initDataRaw();
    return config;
  },
  (error) => Promise.reject(error),
);

// ✅ Извлекаем `response.data.data`
rawApi.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

adminRawApi.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

chatRawApi.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

botRawApi.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error),
);

// 🔧 Оборачиваем стандартные методы с правильной типизацией
type CustomApiInstance = {
  get<T>(url: string, config?: AxiosRequestConfig): Promise<T>;
  post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  delete<T>(url: string, config?: AxiosRequestConfig): Promise<T>;
};

export const api: CustomApiInstance = {
  get: (url, config) => rawApi.get(url, config),
  post: (url, data, config) => rawApi.post(url, data, config),
  put: (url, data, config) => rawApi.put(url, data, config),
  delete: (url, config) => rawApi.delete(url, config),
};

export const adminApi: CustomApiInstance = {
  get: (url, config) => adminRawApi.get(url, config),
  post: (url, data, config) => adminRawApi.post(url, data, config),
  put: (url, data, config) => adminRawApi.put(url, data, config),
  delete: (url, config) => adminRawApi.delete(url, config),
};

export const chatApi: CustomApiInstance = {
  get: (url, config) => chatRawApi.get(url, config),
  post: (url, data, config) => chatRawApi.post(url, data, config),
  put: (url, data, config) => chatRawApi.put(url, data, config),
  delete: (url, config) => chatRawApi.delete(url, config),
};

export const botApi: CustomApiInstance = {
  get: (url, config) => botRawApi.get(url, config),
  post: (url, data, config) => botRawApi.post(url, data, config),
  put: (url, data, config) => botRawApi.put(url, data, config),
  delete: (url, config) => botRawApi.delete(url, config),
};
